@if (isLoading) {
<app-loader class="centerLoader pt-5"></app-loader>
}

@if (!isLoading) {
<div class="container mb-5">
  <div>
    <div class="top">
      <div style="width: 100%;">
        <div class="estimate-title">
          <p class="subtitle-container">{{ variables.imputationDescription || 'Introduce las horas reales dedicadas a
            cada sección.' }}</p>
        </div>
      </div>
    </div>
  </div>
  <hr>
  <div class="estimate-result mt-5">
    <div class="estimate-result-total">
      <!-- Main summary table -->
      <mat-table [dataSource]="summaryDataSource" class="mat-elevation-z8 mat-table-result mat-table-custom mt-3">
        <!-- Name Column (with expandable detail inside) -->
        <ng-container matColumnDef="name">
          <th class="flex-basis-l th-custom text-size result-header" *matHeaderCellDef>
            <span>{{ variables.result || 'Resultado' }}</span>
            @if (hasExpandableSections()) {
            <button mat-icon-button class="custom-button" (click)="toggleAllSections()"
              [matTooltip]="areAllSectionsExpanded() ? (variables.collapseAll || 'Colapsar todo') : (variables.expandAll || 'Expandir todo')">
              <mat-icon>{{areAllSectionsExpanded() ? 'expand_less' : 'expand_more'}}</mat-icon>
            </button>
            }
          </th>
          <td class="flex-basis-l td-custom" *matCellDef="let element"> {{ element.name }}
            @if (element.expandable) {
            <button mat-icon-button class="custom-button" (click)="toggleSection(element.name)">
              <mat-icon>{{ isSectionExpanded(element.name) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
            }
            <!-- Expanded detail sub-table -->
            @if (element.expandable && isSectionExpanded(element.name)) {
            <div class="expand2">
              <mat-table [dataSource]="element.detailDataSource"
                class="detailsContainerWidth open_result_details mat-elevation-z8 mat-table-custom mt-3">
                <!-- Descripción -->
                <ng-container matColumnDef="description">
          <th class="th-custom" style="flex-basis: 200%;" *matHeaderCellDef>{{ variables.description || 'Descripción' }}
          </th>
          <td class="td-custom" style="flex-basis: 200%;" *matCellDef="let item"> {{ item.sectionName }} </td>
        </ng-container>
        <!-- Horas estimadas -->
        <ng-container matColumnDef="estimated">
          <th class="flex-basis-xs th-custom text-end" *matHeaderCellDef>{{ variables.effort || 'Esfuerzo' }} ({{
            variables.hours || 'horas' }})</th>
          <td class="flex-basis-xs td-custom text-end" *matCellDef="let item"> {{ item.estimatedHours.toFixed(2) }}
          </td>
        </ng-container>
        <!-- Horas reales (input) -->
        <ng-container matColumnDef="actual">
          <th class="flex-basis-xs th-custom text-end" *matHeaderCellDef>{{ variables.actualHoursLabel || 'Real (h)' }}
          </th>
          <td class="flex-basis-xs td-custom text-end hours-input-style" *matCellDef="let item">
            @if (this.estimate.state === estimationState.APPROVED) {
            <input type="number" [(ngModel)]="item.actualHours" min="0" step="0.5" class="hours-input"
              [placeholder]="variables.enterHours || 'Horas'" (ngModelChange)="onActualHoursChange()">
            }
            @if (this.estimate.state === estimationState.CLOSED) {
            <div class="hours-input">
              {{ item.actualHours != null ? item.actualHours.toFixed(2) : '-' }}
            </div>
            }
          </td>
        </ng-container>
        <!-- Diferencia -->
        <ng-container matColumnDef="difference">
          <th class="flex-basis-xs th-custom text-end" *matHeaderCellDef>{{ variables.difference || 'Diferencia' }}</th>
          <td class="flex-basis-xs td-custom text-end" *matCellDef="let item" [ngClass]="{'positive-diff': item.actualHours != null && item.actualHours! < item.estimatedHours,
                                'negative-diff': item.actualHours != null && item.actualHours! > item.estimatedHours}">
            {{ item.actualHours != null ? (item.estimatedHours - item.actualHours!).toFixed(2) : '-' }}
          </td>
        </ng-container>

        <mat-header-row class="mat-header-row" *matHeaderRowDef="detailColumns"></mat-header-row>
        <mat-row class="mat-row mat-row-drop" *matRowDef="let row; columns: detailColumns;"></mat-row>
      </mat-table>
    </div>
    }
    </td>
    </ng-container>

    <!-- Estimated Column -->
    <ng-container matColumnDef="estimated">
      <th class="flex-2 text-end th-custom text-size" *matHeaderCellDef>{{ variables.effort || 'Esfuerzo' }} ({{
        variables.hours || 'horas' }})</th>
      <td class="flex-2 text-end td-custom" style="font-weight: bold; overflow: hidden;" *matCellDef="let element">
        {{ element.estimated.toFixed(2) }}
      </td>
    </ng-container>

    <!-- Actual Column -->
    <ng-container matColumnDef="actual">
      <th class="flex-2 text-end th-custom text-size" *matHeaderCellDef>{{ variables.actualHoursLabel || 'Real (h)' }}
      </th>
      <td class="flex-2 text-end td-custom" style="font-weight: bold; overflow: hidden;" *matCellDef="let element">
        {{ element.actual.toFixed(2) }}
      </td>
    </ng-container>

    <!-- Difference Column (only visible in total row) -->
    <ng-container matColumnDef="difference">
      <th class="flex-2 text-end th-custom text-size" *matHeaderCellDef>{{ variables.difference || 'Diferencia' }}</th>
      <td class="flex-2 text-end td-custom" style="font-weight: bold; overflow: hidden;" *matCellDef="let element"
        [ngClass]="{'positive-diff': element.difference != null && element.difference > 0,
                        'negative-diff': element.difference != null && element.difference < 0}">
        {{ element.difference != null ? element.difference.toFixed(2) : '-' }}
      </td>
    </ng-container>

    <mat-header-row class="mat-header-row" *matHeaderRowDef="summaryColumns"></mat-header-row>
    <mat-row class="mat-row mat-row-drop" *matRowDef="let row; let i = index; columns: summaryColumns;"
      [ngClass]="{'genericTotalRow': isLastRow(summaryDataSource, i)}">
    </mat-row>
    </mat-table>
  </div>
</div>
<div class="estimate-result-export mt-3">
  <app-button *hasPermission="Permission.ESTIMATE_IMPUTATION_WRITE"
    [showWhen]="estimate?.state ==estimationState.APPROVED" typeBtn="secondary"
    style="display: flex; position: relative;" (click)="saveImputations()"
    [message]="isSaving ? (variables.saving || 'Guardando...') : (variables.save || 'Guardar')" mat-icon-button
    [matTooltip]="variables.save || 'Guardar imputación'" icon="save" iconPosition='left' width='200px'>
  </app-button>
</div>
</div>
}